module.exports = __webpack_public_path__ + "static/media/sf_3000_gray.37b59381cbd6bba40e42601c091aae6c.png";